// @flow
import React from "react";
import styles from "./SnackBar.scss";
import I18n from "../../../i18n/I18n";
import { Button } from "../";

type Props = {
    postLoading: boolean,
    toggleBar: Function,
    onPrefSubmitWareHouse: Function
}

const SnackBar = (props: Props) => {
    const { postLoading, toggleBar, onPrefSubmitWareHouse } = props;

    return (
        <div className={styles.barWrapper}>
            <div className={styles.barCtr}>
                <span className={styles.helperText}>
                    {I18n.getText(
                        "settings.snackbar-text",
                        {},
                        "You have changed your notification Preference..."
                    )}
                </span>

                <div className={styles.buttonWrapper}>
                    <div>
                        <Button
                            className={styles.ctaBtn}
                            variant="primary"
                            onClick={onPrefSubmitWareHouse}
                        >
                            {postLoading ? (
                                <div className={styles.loader} />
                            ) : (
                                I18n.getText(
                                    "settings.btn-submit",
                                    {},
                                    "Submit"
                                )
                            )}
                        </Button>
                        <span
                            className={styles.dismissText}
                            onClick={toggleBar}
                        >
                            {I18n.getText(
                                "settings.snackbar-dismiss",
                                {},
                                "Dismiss"
                            )}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SnackBar;



// WEBPACK FOOTER //
// ./src/components/common/snackBar/SnackBar.js